export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';



// WEBPACK FOOTER //
// ./src/store/actions/page.js